import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const FEED_INFO_ITEM = Object.freeze({
  ID: '',
  NAME: '',
  TOKEN: '',
});
const RECORD = generateSchema(FEED_INFO_ITEM);
const KEYS: any = generateKeys(FEED_INFO_ITEM);

export class UserFeedInfoItem extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get token(): string {
    return this.get(KEYS.TOKEN);
  }
}
